import API_URLS from '../constants/api-urls';
import axios from './axios';

let persistPromise: Promise<void> | null = null;

const anonymousPersist = (): Promise<void> => {
    if (!persistPromise) {
        persistPromise = axios
            .post(API_URLS.SUBSCRIPTION.ANONYMOUS_PERSIST)
            .then(() => {})
            .catch((error): void => console.error(error instanceof Error ? error.message : error));
    }

    return persistPromise;
};

export default anonymousPersist;
